import { $axios, useAuthTokenError } from '../utils'
import '../typedefs'
import { validateCreateCategory } from '../validators/categories.validators'

/**
 * Get all prayer request categories
 * @param {String} authToken Auth token
 * @returns {import('axios').AxiosResponse<Category[]>}
 */
export function getCategories (authToken) {
  return $axios('/categories', {
    headers: {
      'x-access-token': authToken
    }
  })
}

/**
 * Gets category by id
 * @param {String} id Category id
 * @param {String} authToken Auth token
 * @returns {import('axios').AxiosResponse<Category>}
 */
export function getCategory (id, authToken) {
  return $axios(`/categories/${id}`, {
    headers: {
      'x-access-token': authToken
    }
  })
}

/**
 * Creates a new prayer requests category
 * @param {String} authToken Auth token
 * @param {{ name: String, description: String }} payload Category data
 * @returns {import('axios').AxiosResponse<{ message: String, category: Category }>}
 */
export function createCategory (authToken, payload) {
  useAuthTokenError(authToken)
  validateCreateCategory(payload)

  return $axios('/categories', {
    method: 'POST',
    headers: {
      'x-access-token': authToken
    },
    data: payload
  })
}

/**
 * Updates a prayer requests category
 * @param {String} authToken Auth token
 * @param {String} id Category id
 * @param {{ name: String, description: String }} payload Category data
 * @returns {import('axios').AxiosResponse<{ message: String, category: Category }>}
 */
export function updateCategory (authToken, id, payload) {
  useAuthTokenError(authToken)
  // Same validation for creation is used for updating a category
  validateCreateCategory(payload)

  return $axios(`/categories/${id}`, {
    method: 'PUT',
    headers: {
      'x-access-token': authToken
    },
    data: payload
  })
}

/**
 * Deletes a prayer requests category
 * @param {String} authToken Auth token
 * @param {String} id Category id
 * @returns {import('axios').AxiosResponse<{ message: String }>}
 */
export function deleteCategory (authToken, id) {
  useAuthTokenError(authToken)

  return $axios(`/categories/${id}`, {
    method: 'DELETE',
    headers: {
      'x-access-token': authToken
    }
  })
}
